// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fdb0880f","453":"3765b882"}[chunkId] + ".chunk.js";
};